/*
 * @Author: amy
 * @Date: 2021-04-17 16:05:56
 * @LastEditTime: 2023-05-30 14:17:40
 * @Description: file content
 */

import Vue from 'vue'
import Vuex from 'vuex'
import { getStore, setStore, removeStore } from '@/utils/storage'
import { logout } from '@/api/personal.js'
import {event} from "@ice/stark-data"
Vue.use(Vuex)
function clearStorage () {
  removeStore('privateAccessToken')
  removeStore('userInfo')
  removeStore('industryId')
  removeStore('menu')
  removeStore('projectInfo')
  removeStore('kbBaseUrl')
  removeStore('allMenuCode')
  removeStore('curEnterpriseInfo')
  removeStore('allPermCode')
  removeStore('appId')
  removeStore('industryId')
}
export default new Vuex.Store({
  state: {
    appId: getStore('appId') || '',
    token: getStore('privateAccessToken') || '',
    subMenu: [],
    activeMenu: [],
    userInfo: {},
    projectInfo: {},
    entInfo: {},
    msgCenterCount: 0,
    folding: false,
    isFinalApp: false,
    currentPath: '',
    projectList: [],
    ents: [],
    isEntMenu: false, //是否企业级菜单
    isProjectShow: false,
    entClick: false, //是否点击了企业
    mLogoUrl: '',
    proList: [],
    isProjectSearch: false,
    curWidth: 240,
    alarmMessageList: undefined,  // 长龙航空项目私有-告警弹窗消息列表
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    menu: state => state.menu,
    subMenu: state => state.subMenu,
    activeMenu: state => state.activeMenu,
    projectInfo: state => state.projectInfo,
    entInfo: state => state.entInfo,
    msgCenterCount: state => state.msgCenterCount,
    folding: state => state.folding,
    currentPath: state => state.currentPath,
    projectList: state => state.projectList,
    ents: state => state.ents,
    isEntMenu: state => state.isEntMenu,
    isProjectShow: state => state.isProjectShow,
    entClick: state => state.entClick,
    mLogoUrl: state => state.mLogoUrl,
    proList: state => state.proList,
    isProjectSearch: state => state.isProjectSearch,
    curWidth: state => state.curWidth,
  },
  mutations: {
    SET_ALARM_MESSAGE_LIST(state, alarmMessageList) {
      state.alarmMessageList = alarmMessageList;
    },
    SET_TOKEN(state, token) {
      state.token = token
      setStore('privateAccessToken', token)
    },
    SET_APPID(state, appId) {
      state.appId = appId
      setStore('appId', appId)
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_MENU(state, menu) {
      state.menu = menu
    },
    SET_SUBMENU(state, subMenu) {
      state.subMenu = []
      state.subMenu = subMenu
    },
    SET_ACTIVEMENU(state, activeMenu) {
      state.activeMenu = [activeMenu]
    },
    SET_PROJECTINFO(state, projectInfo) {
      state.projectInfo = projectInfo
    },
    SET_ENTINFO(state, entInfo) {
      state.entInfo = entInfo
    },
    MESSGAE_CENTER_COUNT(state, count) {
      state.msgCenterCount = count
    },
    SET_FOLDING(state, status) {
      state.folding = status
    },
    SET_ENTS(state, ents) {
      state.ents = ents
    },
    CHANGE_SUBAPP_NAME(state, isFinalApp) {
      state.isFinalApp = isFinalApp
    },
    SAVE_CURRENTPATH(state, currentPath) {
      state.currentPath = currentPath
    },
    PROJCT_FETCH(state, entInfo) {
      state.projectList = []
      // const data = {
      //   enterpriseId: entInfo.id,
      //   keywords: ''
      // }
      // const result = [{
      //   address: "",
      //   buildingArea: null,
      //   cityId: null,
      //   code: "",
      //   contact: "",
      //   contactPhone: "",
      //   createdAt: null,
      //   districtId: null,
      //   enterpriseId: null,
      //   id: 2161,
      //   industryId: null,
      //   isDeleted: null,
      //   latitude: "",
      //   longitude: "",
      //   management: "",
      //   name: "乌鲁木齐项目",
      //   occupiedArea: null,
      //   openCode: "",
      //   organizationId: 4353,
      //   provinceId: null,
      //   screenUrl: "",
      //   status: null,
      //   updatedAt: null,
      //   validityDateEnd: null,
      //   validityDateStart: null
      // }]
      // state.projectList = result
      // if(state.projectList.length>0) {
      //   state.projectInfo = state.projectList[0]
      // }
      // queryProjectList(data).then((res) => {
      //   console.error('获取到的项目信息是:', res)
      // })
    },
    MENU_ENT_TYPE(state, isEntMenu) {
      state.isEntMenu = isEntMenu
    },
    CHANGE_PROJECT_SHOW(state, isProjectShow) {
      state.isProjectShow = isProjectShow
    },
    CLICK_ENT(state, entClick) {
      state.entClick = entClick
    },
    M_CUR_LOGO(state, logoUrl) {
      state.mLogoUrl = logoUrl
    },
    SET_PRODS(state, proList) {
      state.proList = proList
    },
    SEARCH_PROJETC(state, isProjectSearch) {
      state.isProjectSearch = isProjectSearch
    },
    ENT_CUR_WIDTH(state, curWidth) {
      state.curWidth = curWidth
    },
  },
  actions: {
    setToken({ commit }, data) {
      commit('SET_TOKEN', data)
    },
    setAppID({ commit }, data) {
      commit('SET_APPID', data)
    },
    async logout({ commit },data) {
      console.log("3");
      event.emit('logout')
      logout(data).then(() => {
          clearStorage()
          removeStore('privateAccessToken')
          sessionStorage.removeItem('projectInfo')
          let getLinkCode = getStore('setLinkCode')
          if(process.env.VUE_APP_ENV == 'xmtyg') { //跳转回到厦门体育馆自己的门户
            //就调用他们那边的退出登录接口
            // if (getStore('formSingle')) {
            //   removeStore('formSingle')
            //   const url = `https://10.20.203.120:8443/idp/profile/OAUTH2/Redirect/GLO?redirctToUrl=https://10.20.203.16:9443/auth/singleLogin&redirectToLogin=true&entityId=ZHAFXT`
            //   window.location.replace(url)
            // }else {
            //   if( getLinkCode &&  getLinkCode !== 'undefined'){
            //     window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
            //   } else {
            //     window.location.reload()
            //   }
            // }
            const url = `https://10.20.203.120:8443/idp/profile/OAUTH2/Redirect/GLO?redirctToUrl=https://10.20.203.16:9443/auth/singleLogin&redirectToLogin=true&entityId=ZHAFXT`
            window.location.replace(url)
          }else if( process.env.VUE_APP_ENV == 'nfmg' ){
            window.location.replace(`${window.location.origin}/auth/login`)
          }else {
            if( getLinkCode &&  getLinkCode !== 'undefined'){
              window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
            } else {
              window.location.reload()
            }
          }

      })
    },
    messageCenterCount({ commit }, count) {
      commit('MESSGAE_CENTER_COUNT', count)
    },
    projectFetch({ commit }, entInfo) {
      commit('PROJCT_FETCH', entInfo)
    }
  },
  modules: {

  }
})
